import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "@/api/axios";
import toastService from "@/services/toastService";
import { Builder_Company_Details } from "./services/KanbanService";
export interface Lead {
  name: string;
  applicant_email: string;
  applicant_phone: string;
  id: number;
  activity_type_id: [number, string];
  activity_type_icon: string;
  activity_summary: string;
  activity_state: string;
  active: boolean;
  activity_calendar_event_id: string;
  activity_date_deadline: string;
  activity_exception_decoration: string;
  activity_exception_icon: string;
  activity_ids: Array<unknown> | null;
  activity_user_id: string;
  avatar_url: string;
  additional_info: string;
  stage_id: [number, string];
  expected_revenue: number;
  prorated_revenue: number;
  display_name: string;
  partner_name: string;
  contact_name: string;
  priority: string;
  color: number;
  company_currency: [number, string];
  tags: {
    id: number;
    name: string;
    display_name: string;
  }[];
  longitude?: string;
  latitude?: string;
  description?: string;
  city?: string;
  city_id?: [number, string];
  state_id: [number, string];
  country_id: [number, string];
  province_id: [number, string];
  region: string;
  address?: string;
  image_url?: string[];
  project_image_ids: { id: number; image_url: string }[];
  permit_issue_date: string;
  project_type_id: [number, string];
  project_class_id: [number, string];
  project_status_id: [number, string];
  owner_email: string;
  owner_company: string;
  owner_name: string;
  applicant_company: string;
  owner_phone: string | boolean;
  project_description: string;
  user_id: [number, string];
  company_id: [number, string];
  builder_id: [number, string];
  // user_avatar: string;
  probability: number;
  builder: {
    builder_company: string;
    id: number;
    partner_id: [number, string];
    company_id: [number, string];
    organization_id: boolean;
    name: string;
    phone: string;
    email: string;
    display_name: string;
    create_uid: [number, string];
    create_date: string;
    write_uid: [number, string];
    write_date: string;
    company_details: Builder_Company_Details;
  };
  color_hex?: string;
  applicant_name: string;
  create_date: string;
}

// ----------------------
// 🟢 Initial State
// ----------------------
interface ListingState {
  listingData: Lead[];
  page: number;
  limit: number;
  totalCount: number;
  filterBody: any;
  loading: boolean;
  error: any;
  // isLoading:boolean;
}

const initialState: ListingState = {
  listingData: [], // ✅ Ab ye Lead[] mana jayega
  page: 1,
  limit: 20,
  totalCount: 0,
  filterBody: {},
  loading: false,
  error: null,
  // isLoading:false

};

// ----------------------
// 🟢 Async thunk: Get listing leads
// ----------------------
export const getListingLeads = createAsyncThunk(
  "listing/getListingLeads",
  async (
    payload: {
      params: {
        page: number;
        limit: number;
        sortBy?: string;
        sortOrder?: string;
        q?: string
      };
      body: {};
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance({
        method: "GET",
        url: "odoo/api/v1/crm/leads",
        params: payload.params,  // ✅ sortBy, sortOrder included automatically
        data: payload.body,
      });
      return response.data.data;
    } catch (error: any) {
      toastService.error("Failed to fetch leads");
      return rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);


// ----------------------
// 🟢 Slice
// ----------------------
const listingSlice = createSlice({
  name: "listing",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setFilterBody: (state, action) => {
      state.filterBody = action.payload;
    },
    resetListingState: () => initialState,
  },
extraReducers: (builder) => {
  builder
    .addCase(getListingLeads.pending, (state) => {
      state.loading = true;
    })
    .addCase(getListingLeads.fulfilled, (state, action) => {
      state.loading = false;

      const incomingPage = action.meta.arg.params.page;

      if (incomingPage === 1) {
  
        state.listingData = action.payload.leads;
      } else {
       
        state.listingData = [...state.listingData, ...action.payload.leads];
      }

      state.totalCount = action.payload.totalCount;
    })
    .addCase(getListingLeads.rejected, (state) => {
      state.loading = false;
      state.listingData = [];
    });
}

});

export const { setPage, setLimit, setFilterBody, resetListingState } = listingSlice.actions;

export default listingSlice.reducer;
